/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const stopwatch_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 5.25a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 0V.75m6 6.75 1.875-1.875M19.5 5.25l.75.75m-6-5.25h-4.5M12 15l-3.75-4.151"
    />
  </svg>
)
export default stopwatch_medium
